import { mutatorAction } from "satcheljs";
import { mailListItemAnimationStore } from "../store/Store";
import type { MailListItemAnimation } from "../store/schema/MailListItemAnimationStore";

// When an animation is completed and the callback is invoked, this mutator will be called to move the
// given active animation to the completedAnimations array.
export const onAnimationCompletedMutator: (animationToRemove: MailListItemAnimation) => void = mutatorAction("onAnimationCompletedMutator", (animationToRemove: MailListItemAnimation): void => {
    // Add the completed animation to the completedAnimations array
    const completedAnimation = mailListItemAnimationStore().activeAnimations.find(activeAnimation => activeAnimation.animationId === animationToRemove.animationId);
    
    if (completedAnimation) {
        mailListItemAnimationStore().completedAnimations.push(completedAnimation);
    }
    
    // Remove the completed animation from the activeAnimations array
    mailListItemAnimationStore().activeAnimations =
        mailListItemAnimationStore().activeAnimations.filter(activeAnimation => {
            return activeAnimation.animationId !== animationToRemove.animationId;
        });
});
